export const QueryParams = {
    RoomIdKey: "roomId",
    DiscussionIdKey: "discussionId",
    IsAnnouncementsOpened: "announcements"
}